var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSend01(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "send-01",
    clipPath: "url(#clip0_1088_2354)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.87513 10.125L15.7501 2.25004M7.97082 10.3711L9.9419 15.4396C10.1155 15.8861 10.2024 16.1094 10.3275 16.1745C10.4359 16.231 10.5651 16.2311 10.6736 16.1747C10.7988 16.1097 10.8859 15.8866 11.06 15.4402L16.0028 2.77444C16.16 2.37155 16.2386 2.17011 16.1956 2.04139C16.1583 1.9296 16.0706 1.84187 15.9588 1.80453C15.8301 1.76153 15.6286 1.84014 15.2257 1.99736L2.55992 6.94012C2.11362 7.11429 1.89046 7.20137 1.82543 7.32655C1.76906 7.43507 1.76913 7.56425 1.82563 7.6727C1.89081 7.7978 2.11407 7.88463 2.56058 8.05827L7.62908 10.0294C7.71972 10.0646 7.76504 10.0822 7.8032 10.1094C7.83702 10.1336 7.8666 10.1631 7.89072 10.197C7.91794 10.2351 7.93557 10.2805 7.97082 10.3711Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1088_2354"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend01);
export default __webpack_public_path__ + "static/media/send-01.729c7b2c773b87c6c70852b0080b5ad8.svg";
export { ForwardRef as ReactComponent };